import { useState } from 'react';

export default function Programs() {
  const [activeTab, setActiveTab] = useState('infant');

  const programs = {
    infant: [
      {
        name: '유아 발산적 사고 프로그램',
        age: '28개월-7세',
        duration: '50분',
        description: '기초 운동 능력과 창의력을 동시에 키우는 통합 프로그램',
        features: ['감각 탐색형 (Sensory Exploration)', '아이디어 확장형 (Idea Expansion)', '표현·상상형 (Imagination & Expression)', '창의적 도전(Creative Challenge)'],
        image: 'https://public.readdy.ai/ai/img_res/7d1280c9d8c9c42eae23c51f386a1e2b.jpg'
      },
      {
        name: '유아 수동적 창의력 프로그램',
        age: '28개월-7세',
        duration: '50분',
        description: '놀이를 통한 인지 발달과 신체 활동의 조화',
        features: ['문제 해결력 사고 프로그램 ', '전략.추론 통합 사고력 프로그램', '집중.기억 기반 통합 학습역량 프로그램 ', '언어·수리 통합 사고력 프로그램'],
        image: 'https://readdy.ai/api/search-image?query=Preschool%20children%20playing%20educational%20games%20with%20attentive%20teachers%20in%20a%20warm%20learning%20space%2C%20soft%20orange%20and%20yellow%20lighting%2C%20kids%20collaborating%20on%20developmental%20activities%20with%20toys%20and%20puzzles%2C%20caring%20instructors%20guiding%20play-based%20learning%2C%20clean%20simple%20background%20with%20natural%20warm%20tones&width=600&height=400&seq=prog-infant-dev-002&orientation=landscape'
      },
      {
        name: '오감 놀이&스토리텔링 프로그램',
        age: '28개월-7세',
        duration: '60분',
        description: '부모와 함께하는 특별한 체험 시간',
        features: ['감각 탐험형 (Sensory Exploration Story)', '이야기 구성형 (Story Building)', '역할·표현 확장형 (Role Play & Expression)', '감각-상상 변형형 (Sensory Imagination Transformation)'],
        image: 'https://readdy.ai/api/search-image?query=Loving%20parents%20and%20young%20children%20playing%20together%20on%20a%20soft%20mat%20in%20a%20cozy%20activity%20center%2C%20warm%20family%20bonding%20moment%20with%20orange%20and%20peach%20tones%2C%20mother%20and%20child%20doing%20developmental%20activities%20together%2C%20joyful%20and%20nurturing%20atmosphere%2C%20simple%20clean%20background%20with%20natural%20lighting&width=600&height=400&seq=prog-infant-dev-003&orientation=landscape'
      }
    ],
    elementary: [
      {
        name: '초등 창의체육 프로그램',
        age: '8-13세',
        duration: '60분',
        description: '체계적인 체육 활동과 창의적 사고의 융합',
        features: ['체력 강화', '전략적 사고', '팀워크', '리더십'],
        image: 'https://readdy.ai/api/search-image?query=Elementary%20school%20children%20aged%208-13%20doing%20structured%20physical%20training%20with%20professional%20instructors%20in%20a%20modern%20sports%20center%2C%20warm%20orange%20and%20teal%20tones%2C%20kids%20exercising%20and%20learning%20teamwork%2C%20energetic%20and%20supportive%20educational%20environment%2C%20simple%20clean%20background&width=600&height=400&seq=prog-elem-dev-001&orientation=landscape'
      },
      {
        name: '창의기법 기반 사고력 프로그램',
        age: '8-13세',
        duration: '60분',
        description: '질문·전환·조합으로 확장하는 창의기법 사고 프로그램',
        features: ['브레인스토밍, 브레인라이팅', 'SCAMPER', '강제결부법', '창의적문제해결능력(CPS)'],
        image: 'https://readdy.ai/api/search-image?query=Children%20playing%20team%20sports%20with%20coaches%20in%20an%20indoor%20facility%2C%20kids%20practicing%20ball%20games%20and%20athletic%20skills%2C%20dynamic%20and%20fun%20atmosphere%20with%20green%20and%20orange%20tones%2C%20professional%20youth%20sports%20training%20environment%2C%20simple%20clean%20background%20with%20natural%20lighting&width=600&height=400&seq=prog-elem-dev-002&orientation=landscape'
      },
      {
        name: '창의융합 STEAM 프로그램',
        age: '8-13세',
        duration: '60분',
        description: '과학, 기술, 예술을 결합한 창의융합 교육',
        features: ['융합적 사고', '실험 활동', '창의적 표현', '문제해결'],
        image: 'https://readdy.ai/api/search-image?query=Children%20doing%20STEAM%20education%20activities%20combining%20science%20experiments%20and%20creative%20projects%20with%20teachers%2C%20kids%20working%20on%20innovative%20learning%20tasks%2C%20modern%20educational%20space%20with%20blue%20and%20orange%20tones%2C%20engaging%20integrated%20learning%20environment%2C%20simple%20clean%20background&width=600&height=400&seq=prog-elem-dev-003&orientation=landscape'
      },
      {
        name: '창의뮤즈 프로그램',
        age: '8-13세',
        duration: '50분',
        description: '아이의 창의적 성장을 이루는 7가지 핵심 역량',
        features: ['호기심 뮤즈 프로그램(Curiosity)', '유희성 뮤즈 프로그램 (Playfulness)', '독립성 뮤즈 프로그램 (Independence)', '집요성 뮤즈 프로그램 (Persistence)'],
        image: 'https://readdy.ai/api/search-image?query=One-on-one%20personalized%20training%20session%20with%20elementary%20student%20and%20caring%20instructor%2C%20individual%20coaching%20in%20a%20supportive%20learning%20environment%2C%20focused%20and%20encouraging%20atmosphere%20with%20teal%20and%20orange%20tones%2C%20professional%20customized%20education%20setting%2C%20simple%20clean%20background&width=600&height=400&seq=prog-elem-dev-004&orientation=landscape'
      }
    ],
    special: [
      {
        name: '스페셜데이',
        age: '전연령',
        duration: '90분',
        description: '여름방학 동안 집중적으로 진행되는 특별 프로그램',
        features: ['깜짝 이벤트', '할로윈데이', '히어로데이', '특별 이벤트'],
        image: 'https://readdy.ai/api/search-image?query=Children%20enjoying%20summer%20vacation%20program%20with%20teachers%20in%20a%20bright%20activity%20center%2C%20kids%20participating%20in%20various%20fun%20educational%20activities%2C%20cheerful%20and%20energetic%20atmosphere%20with%20yellow%20and%20orange%20tones%2C%20exciting%20summer%20learning%20environment%2C%20simple%20clean%20background&width=600&height=400&seq=prog-special-dev-001&orientation=landscape'
      },
      {
        name: '창의력 워크시트 교육 프로그램',
        age: '전연령',
        duration: '90분',
        description: '겨울방학 테마 활동과 체육의 조화',
        features: ['형태 재해석 기반 워크시트', '관점 전환 스토리텔링', '스토리 전개 창의력', '색과 형태 사고력'],
        image: 'https://readdy.ai/api/search-image?query=Children%20in%20winter%20vacation%20program%20doing%20indoor%20creative%20activities%20with%20instructors%2C%20kids%20playing%20in%20a%20warm%20cozy%20learning%20center%2C%20winter%20themed%20environment%20with%20blue%20and%20orange%20tones%2C%20fun%20and%20educational%20holiday%20atmosphere%2C%20simple%20clean%20background&width=600&height=400&seq=prog-special-dev-002&orientation=landscape'
      },
      {
        name: '씽크짐의 독자적 창의력 검사',
        age: '전연령',
        duration: '90분',
        description: '온 가족이 함께 즐기는 주말 특별 프로그램',
        features: ['창의뮤즈검사', '창의력 검사', '인성태도검사', '아동 활동 안내서'],
        image: 'https://readdy.ai/api/search-image?query=Families%20with%20children%20of%20all%20ages%20enjoying%20weekend%20activities%20together%20with%20facilitators%2C%20multi-generational%20family%20bonding%20through%20play%20and%20exercise%2C%20warm%20and%20joyful%20atmosphere%20with%20pink%20and%20orange%20tones%2C%20happy%20family%20recreation%20environment%2C%20simple%20clean%20background&width=600&height=400&seq=prog-special-dev-003&orientation=landscape'
      }
    ]
  };

  return (
    <section id="programs" className="py-12 md:py-20 lg:py-24 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            교육 프로그램
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            연령별, 수준별로 세분화된 전문 교육 프로그램을 만나보세요
          </p>
        </div>

        <div className="flex justify-center mb-8 md:mb-12 px-4">
          <div className="inline-flex bg-white rounded-full p-1 shadow-lg w-full max-w-2xl overflow-x-auto">
            <button
              onClick={() => setActiveTab('infant')}
              className={`flex-1 min-w-[120px] px-4 md:px-8 py-2 md:py-3 rounded-full text-xs md:text-sm font-semibold transition-all whitespace-nowrap ${
                activeTab === 'infant'
                  ? 'bg-orange-500 text-white'
                  : 'text-gray-600 hover:text-orange-500'
              }`}
            >
              유아 (28개월-7세)
            </button>
            <button
              onClick={() => setActiveTab('elementary')}
              className={`flex-1 min-w-[100px] px-4 md:px-8 py-2 md:py-3 rounded-full text-xs md:text-sm font-semibold transition-all whitespace-nowrap ${
                activeTab === 'elementary'
                  ? 'bg-orange-500 text-white'
                  : 'text-gray-600 hover:text-orange-500'
              }`}
            >
              초등 (8-13세)
            </button>
            <button
              onClick={() => setActiveTab('special')}
              className={`flex-1 min-w-[100px] px-4 md:px-8 py-2 md:py-3 rounded-full text-xs md:text-sm font-semibold transition-all whitespace-nowrap ${
                activeTab === 'special'
                  ? 'bg-orange-500 text-white'
                  : 'text-gray-600 hover:text-orange-500'
              }`}
            >
              특별 프로그램
            </button>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {programs[activeTab as keyof typeof programs].map((program, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={program.image}
                  alt={program.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 left-3 md:top-4 md:left-4 bg-orange-500 text-white px-3 py-1 md:px-4 md:py-2 rounded-full text-xs font-semibold">
                  {program.age}
                </div>
              </div>

              <div className="p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{program.name}</h3>
                <p className="text-sm text-gray-600 mb-3 md:mb-4 leading-relaxed">{program.description}</p>

                <div className="space-y-2">
                  {program.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-orange-500 text-sm mt-0.5 flex-shrink-0"></i>
                      <span className="text-xs md:text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
